export default __webpack_public_path__ + "static/media/castration.59b9b151.png";